import { useEffect } from 'react';
import { useAppStore } from '../store/useAppStore';
import clsx from 'clsx';

export default function ShoppingPanel({ eventId }: { eventId: number }) {
  const { shoppingItems, toggleShoppingItem, loadShoppingItems } = useAppStore();
  const list = shoppingItems[eventId] || [];

  useEffect(() => {
    loadShoppingItems(eventId);
  }, [eventId, loadShoppingItems]);

  const totalCost = list.reduce((sum, item) => sum + item.price * item.quantity, 0);
  const purchasedCount = list.filter((i) => i.purchased).length;
  const progress = list.length > 0 ? Math.round((purchasedCount / list.length) * 100) : 0;

  return (
    <div id="panel-shopping" className="ac-card p-5">
      <div id="shopping-header" className="flex items-center gap-2 mb-4">
        <span className="text-2xl">🛒</span>
        <h3 className="font-bold text-lg text-gray-800">采购清单</h3>
        <span className="text-xs text-amber-500 ml-auto">天界传送门 · 核心盈利点</span>
      </div>

      {/* 进度条 */}
      <div className="mb-4">
        <div className="flex justify-between text-xs text-gray-500 mb-1">
          <span>已采购 {purchasedCount}/{list.length} 件</span>
          <span>预估总花费 ¥{totalCost.toFixed(2)}</span>
        </div>
        <div className="h-2 bg-amber-100 rounded-full overflow-hidden">
          <div
            className="h-full rounded-full transition-all"
            style={{ width: `${progress}%`, background: 'linear-gradient(90deg, #f4a261, #e63946)' }}
          />
        </div>
      </div>

      {/* 商品列表 */}
      <div className="space-y-2">
        {list.map((item) => (
          <div
            key={item.id}
            className={clsx(
              'flex items-center gap-3 p-3 rounded-xl border transition-all',
              item.purchased ? 'bg-green-50 border-green-200' : 'bg-white border-amber-100 hover:border-amber-300'
            )}
          >
            {/* 勾选 */}
            <button
              onClick={() => toggleShoppingItem(eventId, item.id)}
              className={clsx(
                'w-6 h-6 rounded-full border-2 flex items-center justify-center flex-shrink-0 transition-all',
                item.purchased ? 'bg-green-400 border-green-400 text-white' : 'border-gray-300 hover:border-amber-400'
              )}
            >
              {item.purchased && '✓'}
            </button>

            <span className="text-2xl">{item.emoji || '🛍️'}</span>

            <div className="flex-1 min-w-0">
              <div className={clsx('font-medium text-sm', item.purchased && 'line-through text-gray-400')}>
                {item.name}
              </div>
              <div className="text-xs text-gray-400">
                {item.category} · ¥{item.price} × {item.quantity}
              </div>
            </div>

            <div className="text-right flex-shrink-0">
              <div className="font-bold text-sm" style={{ color: '#e63946' }}>
                ¥{(item.price * item.quantity).toFixed(2)}
              </div>
            </div>

            {/* 天界传送门 */}
            <a
              href={item.cpsUrl || '#'}
              onClick={(e) => e.preventDefault()}
              className="flex items-center gap-1 text-xs px-3 py-1.5 rounded-lg font-medium text-white whitespace-nowrap"
              style={{ background: '#f4a261' }}
              title="点击跳转第三方电商购买"
            >
              🚪 传送门
            </a>
          </div>
        ))}
      </div>
    </div>
  );
}
